import { countBy, size, keys, first } from 'lodash';
import { useSelector } from 'react-redux';
import { GlobalTypes } from 'redux/types';
import { useCallback, useMemo } from 'react';
import currencies, { currencyDefault } from 'constants/Currencies';
import { useTranslate } from 'context/TranslateContext';


export function reactOption(currencyKey: string,translate: Function) {
  return {
    value: currencyKey,
    label: translate(currencies[currencyKey]?.display || currencyKey),
  };
}

export const convertCurrenciesOptions = (
  currencies: string[],
  translate: Function,
): { label: string; value: string }[] => currencies.map((key) => {return reactOption(key,translate)});

export const useCurrency = (): [
  boolean, // multiCurrency
  string, // currencyFirst
  { value: string; label: string }[], // reactSelectCurrencyOptions
  Record<string, number>, // currenciesInUse
  (currency: string) => boolean, // isCurrencyInUse
] => {
  const { translate,language } = useTranslate();
  const { auth } = useSelector((state: GlobalTypes.RootState) => ({
    auth: state?.auth,
  }));

  // balance currencies that has existed in their account
  const currenciesInUse = useMemo(
    () => countBy(auth?.user?.balance_info_list?.data || [], (item) => item.currency),
    [auth?.user?.balance_info_list?.data],
  );
  const currencyFirst = first(keys(currenciesInUse)) || currencyDefault.value;
  const multiCurrency = size(currenciesInUse) > 1;
  const isCurrencyInUse = useCallback(
    (currency: string) => Boolean(currenciesInUse[currency]),
    [currenciesInUse],
  );
  const reactSelectCurrencyOptions = useMemo(
    () => keys(currenciesInUse).map((key) => {return reactOption(key,translate)}),
    [currenciesInUse,language],
  );

  return [
    multiCurrency,
    currencyFirst,
    reactSelectCurrencyOptions,
    currenciesInUse,
    isCurrencyInUse,
  ];
};
